import "./WarningBanner.css";

function WarningBanner() {

    return (
        <div className="warningBannerContainer">
            <p>This website is a work in progess! Information you're looking for may not be here.</p>
        </div>
    );
};

export default WarningBanner;